import { createSelector } from 'reselect';

const selectRaw = (state) => state.root.layout;

const selectMenuVisible = createSelector(
  [selectRaw],
  (layout) => !!layout.menuVisible,
);

const selectUserMenuVisible = createSelector(
  [selectRaw],
  (layout) => !!layout.userMenuVisible,
);

const selectLanguageVisible = createSelector(
  [selectRaw],
  (layout) => !!layout.languageVisible,
);

const selectLoading = createSelector(
  [selectRaw],
  (layout) => !!layout.loading,
);

const selectLanguage = createSelector(
  [selectRaw],
  (layout) => layout.language,
);

const selectors = {
  selectRaw,
  selectMenuVisible,
  selectLoading,
  selectLanguage,
  selectUserMenuVisible,
  selectLanguageVisible,
};

export default selectors;
